export enum EButtonType {
    ok = 'ok',
    cancel = 'cancel',
    accept = 'accept',
    action = 'action',
}
